<template>
  <exo-help-dialog margin="mt-0 ml-2" title="Drag perturbation">
    It is possible to consider the atmospheric drag perturbation during the
    mission. To this end, the user must ensure that the spacecraft used for the
    mission defines a drag model.
    <br />
    <br />
    The provided fields relative to drag are:
    <li>
      <b>Mean Atmospheric Density:</b> The average value of the atmospheric
      density throughout the mission, computed with the US76 model,
    </li>
    <li>
      <b>Mean Drag:</b> The average value of the drag force throughout the
      mission,
    </li>

    <li>
      <b>ΔV due to Drag:</b> The ΔV generated by the drag. The value is
      positive, if the drag acts against the maneuver, and negative, if the drag
      helps it,
    </li>

    <li>
      <b>Mean Acceleration due to Drag:</b> The average value of the
      acceleration generated by the drag. The value is positive, if the drag
      acts against the maneuver, and negative, if the drag helps it,
    </li>

    <li>
      <b>Drag to Thrust Ratio:</b> Ratio between the maximal drag of the
      maneuver and the thrust.
    </li>
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipDragPerturbationEnabled'
}
</script>
